import { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import type { RegionConfigDto, TenantDto } from '@shared/api-types';
import { adminApiFetch } from '../../lib/adminApiClient';
import { useRegion } from '../../lib/regionContext';

export function Home() {
  const { region } = useRegion();
  const [tenants, setTenants] = useState<TenantDto[] | null>(null);
  const [config, setConfig] = useState<RegionConfigDto | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const [t, c] = await Promise.all([
          adminApiFetch<TenantDto[]>('/api/admin/tenants'),
          adminApiFetch<RegionConfigDto>('/api/admin/region-config'),
        ]);
        if (cancelled) return;
        setTenants(t);
        setConfig(c);
      } catch {
        if (!cancelled) {
          setTenants([]);
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const tenantCount = tenants?.length ?? '…';

  return (
    <div style={{ display: 'grid', gap: 16, gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
      <Card>
        <CardHeader><CardTitle>Region</CardTitle></CardHeader>
        <CardBody>
          <div style={{ fontSize: 28, fontWeight: 600 }}>{region.toUpperCase()}</div>
          <div style={{ color: '#64748b', fontSize: 12 }}>MFA KEK: {config?.mfaKekKeyVersion ?? '…'}</div>
        </CardBody>
      </Card>
      <Card>
        <CardHeader><CardTitle>Tenants in this region</CardTitle></CardHeader>
        <CardBody>
          <div style={{ fontSize: 28, fontWeight: 600 }}>{tenantCount}</div>
          <div style={{ color: '#64748b', fontSize: 12 }}>Catalog row count</div>
        </CardBody>
      </Card>
      <Card>
        <CardHeader><CardTitle>Quick links</CardTitle></CardHeader>
        <CardBody>
          <ul style={{ paddingLeft: 18, margin: 0, lineHeight: 1.7 }}>
            <li><a href="/tenants">Tenants</a></li>
            <li><a href="/email-templates">Email templates</a></li>
            <li><a href="/model-catalog">Model catalog</a></li>
            <li><a href="/platform-admins">Platform admins</a></li>
          </ul>
        </CardBody>
      </Card>
    </div>
  );
}
